import { Col, Menu, Row } from 'antd'
import { StyledMenu } from 'components/GlobalStyles'
import MediumContainer from 'components/MediumContainer'
import Project350 from 'components/Project350/CatalogBanner/index'
import { IS_BONANZA_PROMO_ACTIVE } from 'utils/constants'
import ViewContainer from './container'
import News from './News'
import Promos from './Promos'
import { StyledTabWrapper } from './styles'
import ScBannerV2 from 'components/SuperCard/SupercardBannerV2'

export default function Index({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({ currentTab, setCurrentTab, customPromoBannerAd }) => (
        <div style={{ overflow: 'hidden' }}>
          <MediumContainer>

            <Row style={{ marginBottom: '30px', marginTop: '60px' }}>
              <Col
                xs={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                md={{ span: 24, offset: 0 }}
                lg={{ span: 24, offset: 0 }}
              >
                {IS_BONANZA_PROMO_ACTIVE ? <Project350 /> : <ScBannerV2 />}
              </Col>
            </Row>

            <StyledTabWrapper>
              <Col span={24}>
                <h1>Promos and News</h1>
              </Col>
              <StyledMenu
                onClick={(e) => setCurrentTab(e.key)}
                mode="horizontal"
                selectedKeys={currentTab}
              >
                <Menu.Item key="promos">Promos</Menu.Item>
                <Menu.Item key="news">News</Menu.Item>
              </StyledMenu>
              <Row className="items-wrapper">
                <Col span={24}>
                  {currentTab === 'promos' ? <Promos /> : <News />}
                </Col>
              </Row>
            </StyledTabWrapper>
          </MediumContainer>
        </div>
      )}
    </ViewContainer>
  )
}
